import React, { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { verifyToken } from './redux-saga/reducers/authReducer';
import Spinner from './components/Loader';

const PrivateRoute = ({ children }) => {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const loading = useSelector((state) => state.auth.loading);
  const error = useSelector((state) => state.auth.error);
  const navigate = useNavigate();
  const token = localStorage.getItem('authToken'); 

  useEffect(() => {
    if (token) {
      dispatch(verifyToken(token));
    } else {
      navigate('/login'); // Redirect if no token is found
    }
    if (!isAuthenticated) {
      console.log(isAuthenticated);
      navigate('/login'); 
    }
  }, [dispatch, token, navigate]);

  // Handle case where the token verification failed with a 401 error
  if (error?.response?.status === 401) {
    return <Navigate to="/login" />;
  }

  // Show spinner while loading
  if (loading) {
    return <Spinner />;
  }

  return children;
};

export default PrivateRoute;
